import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AdminServiceService } from 'src/app/services/admin-service.service';
import { AllPortService } from 'src/app/services/all-port.service';
import { BarsicService } from 'src/app/services/barsic.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-view-barsic',
  templateUrl: './view-barsic.component.html',
  styles: [
  ]
})
export class ViewBarsicComponent implements OnInit {


  public questions=[];
  public type = "text";
  public numbers = [];
  public correctNumbers = [];
  public number=0;
  public correctNumber=0;

  public barsicForm = this.fb.group({
    title: [''],
    _id:[''],
    opcA: this.fb.group({
        text:[''],
        value:[0]
    }),
    opcB: this.fb.group({
      text:[''],
      value:[0]
    }),
    opcC: this.fb.group({
      text:[''],
      value:[0]
    }),
    opcD: this.fb.group({
      text:[''],
      value:[0]
    }),
    opcE: this.fb.group({
      text:[''],
      value:[0]
    }),
    numbers: [''],
    correctNumbers:[''],
    factor:[''],
    correctNumberValue:[''],
    type:[''],
    index:['']
  })

  constructor(private fb:FormBuilder, private barsicService:BarsicService, private adminService:AdminServiceService) {
    this.barsicService.getQuestions().subscribe(
      resp=>{
        this.questions = resp;        
      },
      err=>{
        console.log(err);
      }
    )
   }

  ngOnInit(): void {
  }

  handleEdit(id){
    this.barsicService.getQuestion(id).subscribe(
      resp=>{
        console.log(resp);
        this.type=resp.type;
        this.numbers=resp.numbers;
        this.correctNumbers=resp.correctNumbers;
        this.barsicForm.get('title').setValue(resp.title);
        this.barsicForm.get('opcA').setValue(resp.opcA);
        this.barsicForm.get('opcB').setValue(resp.opcB);
        this.barsicForm.get('opcC').setValue(resp.opcC);
        this.barsicForm.get('opcD').setValue(resp.opcD);
        this.barsicForm.get('opcE').setValue(resp.opcE);
        this.barsicForm.get('_id').setValue(resp._id);
        this.barsicForm.get('numbers').setValue(resp.numbers);
        this.barsicForm.get('correctNumbers').setValue(resp.correctNumbers);
        this.barsicForm.get('factor').setValue(resp.factor);
        this.barsicForm.get('correctNumberValue').setValue(resp.correctNumberValue);
        this.barsicForm.get('type').setValue(resp.type);
        this.barsicForm.get('index').setValue(resp.index);

      },
      err=>{
        console.log(err);
      }
    )
    
  }
  update(){
    this.barsicForm.get('numbers').setValue(this.numbers);
    this.barsicForm.get('correctNumbers').setValue(this.correctNumbers);
    this.barsicService.updateQuestion(this.barsicForm.value).subscribe(
      resp=>{

        let timerInterval
        Swal.fire({
          title: 'Pregunta actualizada',
          html: '',
          timer: 1000,
          timerProgressBar: true,
          willOpen: () => {
            Swal.showLoading()
          },
          onClose: () => {
            clearInterval(timerInterval)
          }
        }).then((result) => {
          /* Read more about handling dismissals below */
          if (result.dismiss === Swal.DismissReason.timer) {
            window.location.reload();
          }
        })
      },
      err=>{
        console.log(err);
      }
    )
  }

  addNumber(){
    this.numbers.push(this.number);
    this.number = 0;
  }

  addCorrectNumber(){
    this.correctNumbers.push(this.correctNumber);
    this.correctNumber = 0;
  }

  resetNumbers(){
    this.numbers=[];
    this.correctNumbers=[];

  }
  setSelectedPart(e){
    this.type = e.target.value;
    console.log(e.target.value);
  }

  handleDelete(id){
    var opc = confirm("¿Eliminar pregunta?");
    if (opc==true) this.adminService.deleteQuestion('barsic',id);
  }
  

}
